module.exports = __webpack_public_path__ + "img/Aang-256.92877532.png";